<script setup lang="ts">
export type DonationKind = 'single' | 'recurring'

const model = defineModel<DonationKind | null>({ required: true })

const props = withDefaults(
  defineProps<{
    error?: string
    /** After a choice, collapse the explainer cards into a compact switcher. */
    compact?: boolean
  }>(),
  {
    error: '',
    compact: false,
  }
)
</script>

<template>
  <fieldset
    class="sa-donation-kind"
    :class="{
      'sa-donation-kind--invalid': Boolean(error),
      'sa-donation-kind--compact': compact,
    }"
    :aria-invalid="Boolean(error) || undefined"
    :aria-describedby="error ? 'donation-kind-error' : undefined"
  >
    <legend class="sa-donation-kind__legend" :class="{ 'sa-sr-only': compact }">
      {{ $t('Dashboard.Giving.AddDonationModal.KindLegend') }}
    </legend>
    <div class="sa-donation-kind__options" role="radiogroup">
      <label
        class="sa-donation-kind__card"
        :class="{ 'sa-donation-kind__card--selected': model === 'single' }"
      >
        <input
          id="donation-kind-single"
          v-model="model"
          class="sa-sr-only"
          type="radio"
          name="donation-kind"
          value="single"
        />
        <span class="sa-donation-kind__title">
          {{
            compact
              ? $t('Dashboard.Giving.AddDonationModal.KindSingleShort')
              : $t('Dashboard.Giving.AddDonationModal.KindSingleTitle')
          }}
        </span>
        <span v-if="!compact" class="sa-donation-kind__body">
          {{ $t('Dashboard.Giving.AddDonationModal.KindSingleBody') }}
        </span>
      </label>
      <label
        class="sa-donation-kind__card"
        :class="{ 'sa-donation-kind__card--selected': model === 'recurring' }"
      >
        <input
          id="donation-kind-recurring"
          v-model="model"
          class="sa-sr-only"
          type="radio"
          name="donation-kind"
          value="recurring"
        />
        <span class="sa-donation-kind__title">
          {{
            compact
              ? $t('Dashboard.Giving.AddDonationModal.KindRecurringShort')
              : $t('Dashboard.Giving.AddDonationModal.KindRecurringTitle')
          }}
        </span>
        <span v-if="!compact" class="sa-donation-kind__body">
          {{ $t('Dashboard.Giving.AddDonationModal.KindRecurringBody') }}
        </span>
      </label>
    </div>
    <p
      v-if="error"
      id="donation-kind-error"
      class="sa-field-error"
      role="alert"
    >
      {{ error }}
    </p>
  </fieldset>
</template>
